// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`AddressEditModal general snapshot 1`] = `
<div class="dashboard-inner narrow-modal-body">
  <sectiontitle-stub text="Add Address" data-mr-ass="edit-sub-address" class="app-modal-title"></sectiontitle-stub>
  <form>
    <div class="row">
      <addresseditinputs-stub v="[object Object]"></addresseditinputs-stub>
    </div>
    <div class="row">
      <submitbuttons-stub submittext="Save" submitmethod="function () { [native code] }" submitvisible="true" submitclass="" canceltext="Cancel" cancelmethod="function () { [native code] }" cancelvisible="true"></submitbuttons-stub>
    </div>
  </form>
</div>
`;
